<template>
  <div class="bhb-promote" >
    <img :src="backImg" class="back-img" />
    <div class="input-box">
      <ul>
        <li
        v-for="(item,index) in tableInfo"
        :key="index"
        >
          <InputRow
          :iconSrc="item.icon"
          :inputType="item.type"
          :placeholderText="item.placeholder"
          :imgStyle="item.imgStyle"
          @receive="receive($event,item,index)"
          />
        </li>
      </ul>
      <FetchVerificationCode
        :phone="this.customerInfo.phone"
        @fetchVerificationCode="fetchVerificationCode($event)"
      />
      <SubmitButton
      :disabled="submitDisabled"
      @handleSubmit="handleSubmit()"
      />
    </div>
    <div class="call-button-area">
      <button class="call-button" onclick="window.location.href='tel:19357690618'">
        <div class="call-icon"></div>
        <span>联系客服，立即咨询</span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import FetchVerificationCode from '../blocks/FetchVerificationCode'
import SubmitButton from '../blocks/SubmitButton'
import InputRow from '../components/InputRow'
import imgLoad from '../utils'
import backImg from '../assets/main_back.png'
import iconPhone from '../assets/phone.png'
import iconPoint from '../assets/point.png'
const RECEIVE_NEW_STORAGE = 'receive_new_storage'
const COUPONS_STORAGE = 'coupons_storage'

export default {
  name:'Home',
  components: {
    InputRow,
    FetchVerificationCode,
    SubmitButton
  },
  data() {
    return {
      tableInfo:[
        {
          placeholder:'请输入手机号',
          type:'number',
          icon:iconPhone,
          phone:''
        },
        {
          placeholder:'请输入店铺所在市区（例：杭州市余杭区）',
          type:'text',
          icon:iconPoint,
          address:''
        }
      ],
      verificationCode: '', //验证码
      backImg, // 引入背景图片
      iconPhone,
      iconPoint,
      isSubmiting:false, // 是否正在提交
      key:''
    }
  },

  created() {

  },
  mounted() {
    if(window.location.href.includes('?')){
      const params = qs.parse(window.location.href.split('?')[1])
      this.key = params['retail_key'] || ''
    }
  },
  computed: {
    customerInfo(){
      const obj = {
        phone:this.tableInfo[0].phone,
        address:this.tableInfo[1].address,
        code :this.verificationCode
      }
      return obj
    },
    sendCodeDisabled(){
      return !this.phone || this.isSending
    },
    submitDisabled(){
      return !this.customerInfo.phone || !this.customerInfo.code || !this.customerInfo.address || this.isSubmiting
    }
  },
  methods: {
    // 提交表单信息
    async  handleSubmit() {
      if (this.customerInfo.phone.length !== 11) {
        return window.$toast('请输入正确的手机号')
      } else if (this.customerInfo.address === '') {
        return window.$toast('请输入店铺地址')
      } else if (this.customerInfo.code.length !== 4) {
        return window.$toast('请输入正确的验证码')
      } else {
        const form = {...this.customerInfo,from: 'bhb'}
        if(this.key){
          form.retail_key = this.key
        }
        this.isSubmiting = true
        window.showLoading()
        const res = await axios.post(
          'https://api.duoke.net/index.php/account/get_redbag',
          qs.stringify(form)
        )
        if (res.data.err === 0) {
         this.$router.push('/success')
        } else {
          window.$toast(res.data.msg)
        }
        window.hideLoading()
        this.isSubmiting = false
      }
    },
    //获取手机号码和地址
    receive($event,item,index){
      if(!index){
        item.phone = $event
      } else {
        item.address = $event
      }
    },
    //获取客户输入的验证码
    fetchVerificationCode(e){
      this.verificationCode = e
    }
  }
}
</script>

<style lang="scss" scoped>
.bhb-promote{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .back-img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: auto;
    padding-bottom: calc(var(--raito) * 73px + env(safe-area-inset-bottom));
    z-index: 1;
  }
  .input-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100vw;
    left: 0;
    position: absolute;
    margin-top: calc(var(--raito) * 360px) ;
    padding-left: (30/375) * 100%;
    padding-right: (30/375) * 100%;
    z-index: 11;
    ul{
      padding: 0;
      margin: 0;
      li{
        list-style: none;
      }
    }
  }
  .call-button-area{
    position: fixed;
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
    left: 0;
    z-index: 11;
    width: 100%;
    background-color: #fff;
    padding: calc(var(--raito) * 12px)  (14/375) * 100%;
    .call-button {
      width: 100%;
      height: calc(var(--raito) * 49px);
      display: flex;
      align-items: center;
      gap: calc(var(--raito) * 8px);
      justify-content: center;
      font-family: PingFangSC-Medium;
      font-size: calc(var(--raito) * 17px);
      font-weight: medium;
      color: #192434;
      text-align: center;
      background-image: linear-gradient(127deg, #1BEDE6 0%, #C4EC51 100%);
      border-radius: calc(var(--raito) * 6px);
      .call-icon {
        width: calc(var(--raito) * 19px);
        height: calc(var(--raito) * 19px);
        background-image: url('../assets/call.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 100%;
      }
    }
    .call-button:active {
      opacity: 0.6;
    }
  }
}

</style>
